import script from "./DealersDB.vue?vue&type=script&setup=true&lang=js"
export * from "./DealersDB.vue?vue&type=script&setup=true&lang=js"

import "./DealersDB.vue?vue&type=style&index=0&id=0728102e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0728102e"]])

export default __exports__